import { ChangeDetectionStrategy, Component, inject, input, output, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonHeader, IonContent, IonFooter, ModalController } from '@ionic/angular/standalone';
import { IconComponent, ButtonComponent } from 'libs/shared';
import { SectorsFilters } from 'libs/features/sectors/components/sectors-filters/sectors-filters.component';
import { FiltersPage } from 'libs/features/sectors/models/sector.interfaces';

/**
 * Carcasa única del filtro de sectores/tomas. El contenido lo aporta
 * `lib-sectors-filters`; esta carcasa solo decide la presentación según `variant`:
 *  - 'panel'  → panel responsive (web): sirve de panel lateral en escritorio
 *               (filtra en vivo vía `filtersChange`) y de modal en móvil.
 *  - 'modal'  → modal Ionic (app): ion-header/content/footer con Cancelar/Aceptar.
 * Confirmar/cancelar cierran el modal vía ModalController.
 */
@Component({
  selector: 'lib-sectors-filters-shell',
  standalone: true,
  imports: [
    CommonModule,
    IonHeader, IonContent, IonFooter,
    IconComponent, ButtonComponent, SectorsFilters,
  ],
  templateUrl: './sectors-filters-shell.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectorsFiltersShell {
  private modalCtrl = inject(ModalController);

  filters = input<FiltersPage>({});
  title = input<string>('Filtrar');
  variant = input<'panel' | 'modal'>('panel');

  filtersChange = output<FiltersPage>();

  private draft: FiltersPage | null = null;
  dirty = signal(false);

  onFiltersChange(filters: FiltersPage) {
    this.draft = filters;
    this.filtersChange.emit(filters); // filtrado en vivo (panel escritorio)
  }

  onDirtyChange(dirty: boolean) {
    this.dirty.set(dirty);
  }

  cancel() {
    this.modalCtrl.dismiss(null, 'cancel');
  }

  confirm() {
    this.modalCtrl.dismiss(this.draft ?? this.filters(), 'confirm');
  }
}
